export const ROUTE_ACTIONS = Object.freeze({
  PAYMENT: 'payment',
  CONSULTATION: 'consultation',
});

export const FALLBACK_REDIRECT_TIMEOUT_MS = 1000;
